import { render, staticRenderFns } from "./account-menu-avatar.vue?vue&type=template&id=75c3116f&scoped=true"
import script from "./account-menu-avatar.vue?vue&type=script&lang=js"
export * from "./account-menu-avatar.vue?vue&type=script&lang=js"
import style0 from "./account-menu-avatar.vue?vue&type=style&index=0&id=75c3116f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c3116f",
  null
  
)

/* custom blocks */
import block0 from "./account-menu-avatar.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports